const KNOWN_METHOD_MAPPINGS = {
    'Same Day Delivery': 'same day delivery',
    'Free Rouge Same Day Delivery': 'same day delivery',
    'Schedule a Delivery Window': 'sdd scheduled window'
};

function getShippingSpeedValue(shippingMethodType, isBopis = false) {
    if (isBopis) {
        return 'bopis';
    }

    if (!shippingMethodType) {
        return undefined;
    }

    return KNOWN_METHOD_MAPPINGS[shippingMethodType] || shippingMethodType.toLowerCase();
}

function getScheduledWindowTimestamp(sotV455Value, shippingMethod) {
    if (sotV455Value !== 'sdd scheduled window') {
        return undefined;
    }

    return shippingMethod?.sameDayDeliveryLabel || undefined;
}

function getIsDefaultShippingFlag(currentMethodId, defaultMethodId) {
    if (!currentMethodId || !defaultMethodId) {
        return undefined;
    }

    return currentMethodId === defaultMethodId ? 'true' : 'false';
}

function buildShippingSpeedSOTPayload({ shippingMethod, isBopis = false, defaultMethodId } = {}) {
    const sotV455 = getShippingSpeedValue(shippingMethod?.shippingMethodType, isBopis);
    const sotV456 = getScheduledWindowTimestamp(sotV455, shippingMethod);
    const sotV457 = getIsDefaultShippingFlag(shippingMethod?.shippingMethodId, defaultMethodId);

    const payload = {};

    if (sotV455 !== undefined) {
        payload.sotV455 = sotV455;
    }

    if (sotV456 !== undefined) {
        payload.sotV456 = sotV456;
    }

    if (sotV457 !== undefined) {
        payload.sotV457 = sotV457;
    }

    return payload;
}

export {
    getShippingSpeedValue, getScheduledWindowTimestamp, getIsDefaultShippingFlag, buildShippingSpeedSOTPayload
};
